import React from "react";
import { IconBaseProps } from "react-icons";

export const ChatBubbleSVG: React.FC<IconBaseProps> = ({ fill = "currentColor", size = 26 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 26 26"
    fill={fill}
    fillRule="evenodd"
    display="block"
  >
    <path d="M7.102 17.126l-.221-.272A7.031 7.031 0 0 1 5.369 12.5C5.369 8.367 9.02 5 13.5 5s8.114 3.367 8.114 7.5-3.65 7.5-8.132 7.5a8.754 8.754 0 0 1-3.78-.867L9.5 19.03l-.222.068c-1.493.425-2.95.663-4.186.663H5a21.318 21.318 0 0 0 1.881-2.347l.221-.29z" />
  </svg>
);
